import { locationApi } from './locationApi';
import { virtualDevicesApi } from './virtualDevicesApi';

export * from './virtualDevicesApi';
export * from './locationApi';

export const businessApiSlices = [virtualDevicesApi, locationApi];
